import { TICKET_STATUSES, type TicketStatus } from '../../types/bpTickets';
import { statusChipClass } from './statusColors';
import { SELECT_CHEVRON } from './chevron';

/** The status control doubles as its own display — a colored pill that is also the change dropdown. */
export function StatusSelect({
  status,
  onChange,
  disabled,
}: {
  status: TicketStatus;
  onChange: (status: TicketStatus) => void;
  disabled?: boolean;
}) {
  // A status renamed in Airtable arrives here unchanged — deliberately, because
  // updateTicketStatus writes the name straight back, so normalising it to an
  // option Airtable no longer has would break the write instead of the display.
  // Surface it as an extra option so the controlled select still shows the
  // ticket's real state rather than rendering blank.
  const options = TICKET_STATUSES.includes(status)
    ? TICKET_STATUSES
    : [status, ...TICKET_STATUSES];
  return (
    <select
      value={status}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as TicketStatus)}
      style={{ backgroundImage: SELECT_CHEVRON, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 8px center', backgroundSize: '10px' }}
      className={`appearance-none rounded border-0 py-1 pl-2 pr-6 text-xs font-medium disabled:opacity-60 ${statusChipClass(status)}`}
    >
      {options.map((s) => (
        <option key={s} value={s}>
          {s}
        </option>
      ))}
    </select>
  );
}
